(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bogforum-hero"] && !Shopify.designMode) return;
  try {
    
  class BogforumStickyCta extends HTMLElement {
    connectedCallback() {
      const target = document.getElementById(this.dataset.target);
      if (!target) return;
      this.done = false;

      this.observer = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.hidden = this.done || !passed;
      });
      this.observer.observe(target);

      this.onKlaviyo = (event) => {
        const detail = event.detail || {};
        if (detail.type === 'submit' && (!this.dataset.formId || detail.formId === this.dataset.formId)) {
          this.done = true;
          this.hidden = true;
        }
      };
      window.addEventListener('klaviyoForms', this.onKlaviyo);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('klaviyoForms', this.onKlaviyo);
    }
  }

  if (!customElements.get('bogforum-sticky-cta')) customElements.define('bogforum-sticky-cta', BogforumStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
